export const hideElement = element => {
    if (!element) {
        return;
    }

    element.style.position = 'absolute';
    element.style.top = '0';
    element.style.transform = 'translateY(-200%)';
    element.style.overflow = 'hidden';
    element.style.pointerEvents = 'none';
};
export const showElement = element => {
    if (!element) {
        return;
    }

    element.style.position = '';
    element.style.top = '';
    element.style.transform = '';
    element.style.overflow = '';
    element.style.pointerEvents = 'auto';
};
